/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
export var SearchServiceErrorType;
(function (SearchServiceErrorType) {
    SearchServiceErrorType["networkError"] = "SearchService.NetworkError";
    SearchServiceErrorType["itemNotFound"] = "SearchService.ItemNotFound";
    SearchServiceErrorType["decodingError"] = "SearchService.DecodingError";
    SearchServiceErrorType["searchEngineError"] = "SearchService.SearchEngineError";
})(SearchServiceErrorType || (SearchServiceErrorType = {}));
export class SearchServiceError extends Error {
    constructor(type, message, details) {
        super(message);
        this.name = type;
        this.type = type;
        this.details = details;
    }
}
//# sourceMappingURL=search-service-error.js.map